import { api } from '@/services';

function buildURLSearchParams(payload) {
  const params = new URLSearchParams();

  Object.keys(payload).forEach((key) => {
    const value = payload[key];
    if (Array.isArray(value)) {
      params.append(key, value.join(','));
    } else if (typeof value === 'object' && value !== null) {
      Object.keys(value).forEach((subKey) => {
        params.append(`${key}${subKey.charAt(0).toUpperCase() + subKey.slice(1)}`, value[subKey]);
      });
    } else if (value) {
      params.append(key, value);
    }
  });

  return params;
}

export default {
  async fetchRepliquesNFeItems({ commit, dispatch }, payload) {
    const params = buildURLSearchParams(payload);

    dispatch('toggleLoading', true, { root: true });

    const { data } = await api.get('/repliquesNFe', { params });

    commit('SET_REPLIQUES_NFE_TABLE_ITEMS', data.data);
    commit('paginacao/SET_PAGINADOR', data, { root: true });

    dispatch('toggleLoading', false, { root: true });
  },
  async filtrar({ commit }, payload) {
    commit('SET_FILTROS', payload);
  },
  async prepararExcel({ getters }) {
    const { getFiltros } = getters;

    const params = buildURLSearchParams(getFiltros);

    const { data } = await api.get('/repliquesNFe/excel', { params });

    if (!data) return null;

    const excelFormatado = data.map((infoDist) => ({
      wmsFilial: infoDist.wmsFilial,
      conexosFilial: infoDist.conexosFilial,
      wmsNumeroDocumento: infoDist.wmsNumeroDocumento,
      conexosNumeroDocumento: infoDist.conexosNumeroDocumento,
      wmsDataEmissao: infoDist.wmsDataEmissao,
      conexosDataEmissao: infoDist.conexosDataEmissao,
      wmsDataMovimento: infoDist.wmsDataMovimento,
      conexosDataMovimento: infoDist.conexosDataMovimento,
      wmsChaveAcesso: infoDist.wmsChaveAcesso,
      conexosChaveAcesso: infoDist.conexosChaveAcesso,
      wmsStatus: infoDist.wmsStatus,
      conexosStatus: infoDist.conexosStatus,
      wmsCodigoBeneficio: infoDist.wmsCodigoBeneficio,
      conexosCodigoBeneficio: infoDist.conexosCodigoBeneficio,
      wmsICMS: infoDist.wmsICMS,
      conexosICMS: infoDist.conexosICMS,
      wmsBaseICMS: infoDist.wmsBaseICMS,
      conexosBaseICMS: infoDist.conexosBaseICMS,
      wmsFrete: infoDist.wmsFrete,
      conexosFrete: infoDist.conexosFrete,
      wmsTotalProdutos: infoDist.wmsTotalProdutos,
      conexosTotalProdutos: infoDist.conexosTotalProdutos,
      wmsTotalDocumento: infoDist.wmsTotalDocumento,
      conexosTotalDocumento: infoDist.conexosTotalDocumento,
    }));

    return excelFormatado;
  },
};
